// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '../../Geometry';
import { BaseMap } from './BaseMap';
import { IndustryMap } from './IndustryMap';
export class SectorMap extends BaseMap {
    get selectedIndustry() {
        for (const item of this.items) {
            if (item.isSelected) {
                return item;
            }
        }
        return undefined;
    }
    get industryHeaderHeight() {
        return this.parentMapContainer.industryHeaderHeight;
    }
    constructor(parentMapContainer, sectorName, data) {
        super();
        this.headerRectangle = Rectangle.Empty();
        this.isHidden = false;
        this.isSelected = false;
        this.parentMapContainer = parentMapContainer;
        this.sectorName = sectorName;
        const groupedData = this.groupByIndustry(data);
        groupedData.forEach((group) => {
            this.addItem(new IndustryMap(this, group.key, group.items));
        });
    }
    get Visible() {
        return !this.isHidden && this.isVisible();
    }
    get VisibleCount() {
        return this.items.reduce((sum, item) => sum + item.VisibleCount, 0);
    }
    recalculateArea() {
        const rect = new Rectangle(this.Rectangle.X + SectorMap.BORDER, this.Rectangle.Y + SectorMap.BORDER, this.Rectangle.Width - 2 * SectorMap.BORDER, this.Rectangle.Height - 2 * SectorMap.BORDER);
        const headerHeight = Math.min(this.parentMapContainer.sectorHeaderHeight, rect.Height);
        const bodyRect = new Rectangle(rect.X, rect.Y + headerHeight, rect.Width, rect.Height - headerHeight);
        this.headerRectangle = new Rectangle(rect.X, rect.Y, rect.Width, headerHeight);
        this.recalculateTreeMap(bodyRect);
        this.items
            .filter((y) => y.Visible)
            .forEach((x) => {
            x.recalculateArea();
        });
    }
    getSymbolBackgroundColor(intervalDot) {
        return this.parentMapContainer.getSymbolBackgroundColor(intervalDot);
    }
    groupByIndustry(data) {
        const groups = {};
        data.forEach((item) => {
            if (!groups[item.industry]) {
                groups[item.industry] = [];
            }
            groups[item.industry].push(item);
        });
        return Object.keys(groups).map((key) => ({ key, items: groups[key] }));
    }
}
SectorMap.BORDER = 1;
